import {
  LOGIN_USER,
  SET_LOADING,
  ERROR,
  GET_RECEIPES,
  SEARCH,
  CLEAR_SEARCH,
  GET_TOP_RECEIPES,
  GET_UNDERATED_RECEIPES,
  GET_TODAY_RECIEPES,
} from "../constants/types";

const initialState = {
  login: false,
  receipes: [],
  todaysRecipes: [],
  loading: false,
  isAdmin: null,
  error: null,
  topReceipes: [],
  underRatedReceipes: [],
};

export const receipeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_USER:
      return {
        ...state,
        login: true,
        isAdmin: payload,
      };
    case GET_RECEIPES:
      return {
        ...state,
        receipes: payload,
      };
    case GET_TOP_RECEIPES:
      return {
        ...state,
        topReceipes: payload,
      };
    case GET_TODAY_RECIEPES:
      return {
        ...state,
        todaysRecipes: payload,
      };
    case GET_UNDERATED_RECEIPES:
      return {
        ...state,
        underRatedReceipes: payload,
      };
    case SEARCH:
      return {
        ...state,
        filter: state.receipes.filter((receipe) =>
          receipe.data.title.match(new RegExp(`${payload}`, "gi"))
        ),
      };
    case CLEAR_SEARCH:
      return {
        ...state,
        filter: null,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};
